// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file auth.proto (package river, syntax proto3)
/* eslint-disable */
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file auth.proto.
 */
export const file_auth = /*@__PURE__*/ fileDesc("CgphdXRoLnByb3RvEgVyaXZlciItChpTdGFydEF1dGhlbnRpY2F0aW9uUmVxdWVzdBIPCgd1c2VyX2lkGAEgASgMInEKG1N0YXJ0QXV0aGVudGljYXRpb25SZXNwb25zZRIPCgd1c2VyX2lkGAEgASgMEhEKCWNoYWxsZW5nZRgCIAEoDBIuCgpleHBpcmF0aW9uGAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKMAQobRmluaXNoQXV0aGVudGljYXRpb25SZXF1ZXN0Eg8KB3VzZXJfaWQYASABKAwSEQoJc2lnbmF0dXJlGAIgASgMEhQKDGRlbGVnYXRlX3NpZxgDIAEoDBIgChhkZWxlZ2F0ZV9leHBpcnlfZXBvY2hfbXMYBCABKAMSEQoJY2hhbGxlbmdlGAUgASgMIjUKHEZpbmlzaEF1dGhlbnRpY2F0aW9uUmVzcG9uc2USFQoNc2Vzc2lvbl90b2tlbhgBIAEoCTLWAQoVQXV0aGVudGljYXRpb25TZXJ2aWNlElwKE1N0YXJ0QXV0aGVudGljYXRpb24SIS5yaXZlci5TdGFydEF1dGhlbnRpY2F0aW9uUmVxdWVzdBoiLnJpdmVyLlN0YXJ0QXV0aGVudGljYXRpb25SZXNwb25zZRJfChRGaW5pc2hBdXRoZW50aWNhdGlvbhIiLnJpdmVyLkZpbmlzaEF1dGhlbnRpY2F0aW9uUmVxdWVzdBojLnJpdmVyLkZpbmlzaEF1dGhlbnRpY2F0aW9uUmVzcG9uc2VCNFoyZ2l0aHViLmNvbS90b3ducy1wcm90b2NvbC90b3ducy9jb3JlL25vZGUvcHJvdG9jb2xiBnByb3RvMw", [file_google_protobuf_timestamp]);
/**
 * Describes the message river.StartAuthenticationRequest.
 * Use `create(StartAuthenticationRequestSchema)` to create a new message.
 */
export const StartAuthenticationRequestSchema = /*@__PURE__*/ messageDesc(file_auth, 0);
/**
 * Describes the message river.StartAuthenticationResponse.
 * Use `create(StartAuthenticationResponseSchema)` to create a new message.
 */
export const StartAuthenticationResponseSchema = /*@__PURE__*/ messageDesc(file_auth, 1);
/**
 * Describes the message river.FinishAuthenticationRequest.
 * Use `create(FinishAuthenticationRequestSchema)` to create a new message.
 */
export const FinishAuthenticationRequestSchema = /*@__PURE__*/ messageDesc(file_auth, 2);
/**
 * Describes the message river.FinishAuthenticationResponse.
 * Use `create(FinishAuthenticationResponseSchema)` to create a new message.
 */
export const FinishAuthenticationResponseSchema = /*@__PURE__*/ messageDesc(file_auth, 3);
/**
 * AuthenticationService provides client functionality to obtain a session token that can be used
 * in the NotificationService.
 *
 * @generated from service river.AuthenticationService
 */
export const AuthenticationService = /*@__PURE__*/ serviceDesc(file_auth, 0);
//# sourceMappingURL=auth_pb.js.map